<template>
  <div class="login-box">
    <van-dialog
      v-model="showLogin"
      :closeOnClickOverlay="true"
      :showConfirmButton="false"
      ref="dialog"
    >
      <!-- <div v-if="!isWeixin">
        <div>
          <p v-if="!websocket" class="text-danger text-center">二维码生成中……</p>
          <div class="d-flex">
            <p class="text-center" id="login-box"></p>
            <p v-if="qrcodeMsg" class="text-danger text-center">{{ qrcodeMsg }}</p>
          </div>
        </div>
      </div> -->
    </van-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import * as types from 'jystore/mutation-types';
import tools from '@/utils/tools';
export default {
  mixins: [tools],
  components: {
  },
  props: {
    backUrl: String
  },
  data() {
    return {
      showLogin: false,
      qrcodeUrl: null,
      websocket: null,
      qrcodeMsg: '',
    }
  },
  computed: {
    ...mapState(['c_token'])
  },
  watch: {
    c_token(val) {
      if (this.websocket && this.websocket.readyState === 1) {
        let params = { token: this.$store.state.c_token };
        this.websocket.send(JSON.stringify(params));
      }
    },
    showLogin(val) {
      if (val) {
        this.$store.dispatch(types.JY_TOKEN_GET, () => {
          this.login();
        });
      }
    }
  },
  mounted () {
    this.initWebSocket();
  },
  methods: {
    show(flag) {
      this.showLogin = flag ? true : false;
    },
    initWebSocket() {
      if (!this.websocket) {
        this.timerWebsocket = setInterval(() => {
          this.connWebscoket();
        }, 1000);
      }
    },
    // 微信扫码登录
    initWx() {
      let wx_root = this.$axios.defaults.wx_root;
      let obj = {
        self_redirect: true,
        id: 'lpy_login_container_2',
        appid: 'wxee1c2a02d181dc73',
        scope: 'snsapi_login',
        redirect_uri: encodeURIComponent(wx_root +'vue/login/login4wx?token='+ this.$store.state.c_token +'&rr='+ !(this.websocket)),
        state: this.$store.state.c_token,
        style: '',
        href: ''
      };
      let d = document.createElement('iframe'), e = 'https://lupengyou.com/get-weixin-code.html?appid=' + obj.appid + '&scope=' + obj.scope + '&redirect_uri=' + obj.redirect_uri + '&state=' + obj.state + '&login_type=jssdk&self_redirect=' + obj.self_redirect;
      e += obj.style ? '&style=' + obj.style :'', e += obj.href ? '&href=' + obj.href :'', d.src = e,
      d.frameBorder = '0', d.allowTransparency = 'true', d.scrolling = 'no', d.width = '290px',
      d.height = '360px';
      // console.log(this.$refs.dialog.$el)
      let f = this.$refs.dialog.$el.querySelector('#login-box');
      f.innerHTML = '', f.appendChild(d);
      // console.log(obj.redirect_uri)
    },
    logout() {
      this.$store.dispatch(types.JY_LOGOUT, () => {
        this.$router.push('/');
      });
    },
    login() {
      // 如果已登录
      // if (this.member.id) {
      //   this.$emit('login');
      //   return;
      // }
      // 微信浏览器 - 跳转登录
      // if (this.isWeixin) {
        // 记录登录后回调的url
        this.$store.commit(types.JY_BACKURL, {backUrl: this.backUrl || null});
        // 跳转到微信登录
        top.location.href = this.rootPath +'vue/login/loginOpen?c_token='+ this.$store.state.c_token;
      // }
      // 否则，扫码登录
      // else {
      //   this.connWebscoket(() => {
      //     this.$nextTick(() => {
      //       // 获取最新的c_token
      //       this.$store.dispatch(types.JY_TOKEN_GET, () => {
      //         this.initWx();
      //       });
      //     });
      //   });
      // }
    },
    login4Token() {
      // console.log(this.token)
      if (this.token) {
        this.$store.dispatch(types.JY_LOGIN_TOKEN, {
          newtoken: this.token,
          callback: (flag) => {
            console.log(flag, this.backUrl)
            if (flag) {
              let backUrl = this.backUrl;
              if (backUrl) {
                this.$store.commit(types.JY_BACKURL_CLEAR);
                this.$router.push(backUrl);
              }
            }
          }
        });
      }
    },
    connWebscoket(callback) {
      // websocket
      if (!this.websocket || this.websocket.readyState > 1) {
        this.websocket = new WebSocket(this.$axios.defaults.wsroot +"/login.ws");
      }
      if (this.websocket) {
        if (this.timerWebsocket) {
          clearInterval(this.timerWebsocket);
          this.timerWebsocket = null;
        }
        this.doWebscoket();
        // if (!this.isWeixin) {
        //   this.$nextTick(() => {
        //     this.initWx();
        //   });
        // }
        if (callback) {
          callback();
        }
      }
    },
    doWebscoket() {
      //连接成功建立的回调方法
      this.websocket.onopen = () => {
        // 发送token到服务器
        if (this.websocket && this.websocket.readyState === 1) {
          let params = { token: this.$store.state.c_token };
          this.websocket.send(JSON.stringify(params));
        }
      };
      // websocket - onmessage
      this.websocket.onmessage = (event) => {
        //console.log(event);
        let json = JSON.parse(event.data);
        // console.log(json)
        this.qrcodeMsg = '';
        if (json.nickname) {
          let params = {obj: json};
          // console.log(params)
          params[types.KEY_STATUS] = types.CODE_SUCCESS;

          this.$store.commit(types.JY_LOGIN, {json: params, callback: (flag, msg) => {
              if (flag) {
                this.$emit('login');
                this.websocket && this.websocket.close();
              }
            }
          });
        } else if (json.message) {
          this.qrcodeMsg = json.message;
        }
      };
      //连接发生错误的回调方法
      this.websocket.onerror = () => {
        console.log("WebSocket连接发生错误");
        this.websocket = null;
        this.timerWebsocket && (clearInterval(this.timerWebsocket));
        this.timerWebsocket = setInterval(() => {
          this.connWebscoket();
        }, 1000);
      };
    },
  }
}
</script>
<style lang="less" scoped>
.login-box /deep/ {
  .text-center{text-align:center;}
  .d-flex{.flex-column();}
  .van-dialog {
    top:50%;
    transform:translate(-50%, -50%);
  }
}
</style>